import { consoleEvents } from '@pb/utils'

import {
  updateFetchedCities,
  updateFetchedDistricts,
  updateFetchedPostalCode,
} from 'features/checkout/duck/actions'
import { loadCities, loadDistricts } from 'features/checkout/requests'
import { ThunkResult } from 'redux/types'

import { operationFetchPostalCode } from './loadPostalCode'

interface FetchCitiesProps {
  provinces: Record<string, string>
  value: string
}

interface FetchDistrictsProps {
  cities: Record<string, string>
  value?: string
  getPostalCode?: boolean
}

interface FetchCityAndDistrictProps {
  provinces: Record<string, string>
  selectedProvince?: string
  selectedCity?: string
  getPostalCode?: boolean
}

export const operationFetchCities =
  ({ provinces, value }: FetchCitiesProps): ThunkResult<void> =>
  async (dispatch) => {
    try {
      const provinceCode = Object.keys(provinces).find((key) => provinces[key] === value)
      dispatch(updateFetchedCities({}))
      dispatch(updateFetchedDistricts({}))
      dispatch(updateFetchedPostalCode(''))
      const cities = await loadCities(provinceCode || '')
      dispatch(updateFetchedCities(cities))
    } catch (error) {
      consoleEvents.error('Could not load Cities', error)
    }
  }

export const operationFetchDistricts =
  ({ cities, value, getPostalCode }: FetchDistrictsProps): ThunkResult<void> =>
  async (dispatch) => {
    try {
      const cityCode = Object.keys(cities).find((key) => cities[key] === value)
      dispatch(updateFetchedDistricts({}))
      dispatch(updateFetchedPostalCode(''))
      const districts = await loadDistricts(cityCode || '')
      dispatch(updateFetchedDistricts(districts))

      if (getPostalCode && cityCode) {
        dispatch(operationFetchPostalCode(cityCode))
      }
    } catch (error) {
      consoleEvents.error('Could not load Districts', error)
    }
  }

export const operationFetchCityAndDistrict =
  ({
    provinces,
    selectedProvince,
    selectedCity,
    getPostalCode,
  }: FetchCityAndDistrictProps): ThunkResult<void> =>
  async (dispatch) => {
    try {
      const provinceCode = Object.keys(provinces).find((key) => provinces[key] === selectedProvince)
      if (!provinceCode) {
        return
      }
      dispatch(updateFetchedCities({}))
      dispatch(updateFetchedDistricts({}))
      dispatch(updateFetchedPostalCode(''))
      const cities = await loadCities(provinceCode || '')
      dispatch(updateFetchedCities(cities))
      dispatch(operationFetchDistricts({ cities, value: selectedCity }))

      if (getPostalCode && cities) {
        const cityCode = Object.keys(cities).find((key) => cities[key] === selectedCity)
        dispatch(operationFetchPostalCode(cityCode))
      }
    } catch (error) {
      consoleEvents.error('Could not load Cities and districts', error)
    }
  }
